var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"pa-0"},[_c('h2',[_vm._v("Delivery Data")]),_c('br'),_vm._v(" Discrepancy Dashboard "),_c('br'),_vm._v(" Pacing Dashboard ")])
}
var staticRenderFns = []

export { render, staticRenderFns }